
// src/components/Header.js

import '../styles/Header.css';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Authorization from './utils/Authorization';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const withRandomParam = (path) => `${path}${path.includes('?') ? '&' : '?'}r=${Math.random()}`;

  // Close mobile menu on navigation
  useEffect(() => {
    const closeMenu = () => setMobileMenuOpen(false);
    window.addEventListener('resize', closeMenu);
    return () => window.removeEventListener('resize', closeMenu);
  }, []);

  // Dropdown submenu click handling for desktop
  useEffect(() => {
    const handler = (e) => {
      const submenu = e.target.nextElementSibling;
      if (submenu && submenu.classList.contains('dropdown-menu')) {
        e.preventDefault();
        e.stopPropagation();
        document.querySelectorAll('.dropdown-submenu .dropdown-menu.show').forEach((el) => {
          if (el !== submenu) el.classList.remove('show');
        });
        submenu.classList.toggle('show');
      }
    };
    const triggers = document.querySelectorAll('.dropdown-submenu > a');
    triggers.forEach((el) => el.addEventListener('click', handler));
    const closeAll = () => {
      document.querySelectorAll('.dropdown-submenu .dropdown-menu.show').forEach((el) => {
        el.classList.remove('show');
      });
    };
    document.addEventListener('click', closeAll);
    return () => {
      triggers.forEach((el) => el.removeEventListener('click', handler));
      document.removeEventListener('click', closeAll);
    };
  }, []);

  return (
    <header>
      <div className="header-area fixed-top text-secondary">
        <div id="sticky-header" className="main-header-area">
          <div className="container">
            <div className="row align-items-center">

              {/* Logo */}
              <div className="col-xl-3 col-lg-2 col-6">
                <div className="logo">
                  <Link to={withRandomParam("/home")}>
                    <img src={`${process.env.PUBLIC_URL}/images/mrlogoBO.png`} style={{ maxHeight: '50px' }} alt="Logo" />
                  </Link>
                </div>
              </div>

              {/* Desktop menu */}
              <div className="col-xl-8 col-lg-8 d-none d-lg-block">
                <nav >
                  <ul id="navigation" className="mb-0 nav">
                    <li className="nav-item">
                      <Link className="nav-link text-secondary" to={withRandomParam("/home")}>Home</Link>
                    </li>
                    <li className="nav-item dropdown">
                      <a className="nav-link dropdown-toggle text-secondary" href="#" id="alertDropdown" data-bs-toggle="dropdown" aria-expanded="false">Alerts</a>
                      <ul className="dropdown-menu" aria-labelledby="alertDropdown">
                        <li><Link className="dropdown-item" to={withRandomParam("/alerts/createalert")}>Create Alert</Link></li>
                        <li><Link className="dropdown-item" to={withRandomParam("/alerts/alertclient")}>Alert Client Association</Link></li>
                        <li><Link className="dropdown-item" to={withRandomParam("/alerts/repository")}>Alert Repository</Link></li>
                      </ul>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link text-secondary" to={withRandomParam("/emails/displayEmailNotices")}>Mail Notice</Link>
                    </li>

					{/* Desktop Admin Menu */}
					<Authorization allowed={['SUPER', 'ADMIN', 'ALL_PRIV']}>
					  <li className="nav-item dropdown">
					    <a className="nav-link dropdown-toggle text-secondary" href="#" id="adminDropdown" data-bs-toggle="dropdown" aria-expanded="false">Admin</a>
					    <ul className="dropdown-menu" aria-labelledby="adminDropdown">
					      <li><Link className="dropdown-item" to={withRandomParam("/routing/displayRouting")}>Display Routings</Link></li>
					      <li><Link className="dropdown-item" to={withRandomParam("/routing/resolveRouting")}>Resolve Routings</Link></li>
					      <li><Link className="dropdown-item" to={withRandomParam("/datainfo/displayClientDataInfo")}>Client Data Upload Info</Link></li>
					      <li><Link className="dropdown-item" to={withRandomParam("/datainfo/displayClientData")}>View Client Data</Link></li>
					      <Authorization allowed={['ADMIN']}>
					        <li><Link className="dropdown-item" to={withRandomParam("/trackutil")}>Tracking Utilities</Link></li>
					      </Authorization>
					    </ul>
					  </li>
					</Authorization>

                    <li className="nav-item">
                      <a className="nav-link text-secondary" href={withRandomParam("/help")} target="_blank" rel="noopener noreferrer">Help</a>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link text-secondary" to={withRandomParam("/logout")}>Logout</Link>
                    </li>
                  </ul>
                </nav>
              </div>

              {/* Mobile menu toggle button */}
              <div className="col-6 d-block d-lg-none text-end">
                <button
                  id="mobileMenuBtn"
                  className="btn btn-outline-secondary"
                  type="button"
                  onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                  aria-label="Toggle mobile menu"
                >
                  <span className="fa fa-bars"></span>
                </button>
              </div>

              {/* Mobile menu */}
              <div className="col-12">
			  <div
			    id="mobileMenu"
			    className="mobile_menu d-lg-none"

				style={{
				  display: mobileMenuOpen ? 'block' : 'none',
				  background: '#fff',
				  zIndex: 1050,
				  boxShadow: '0 0.5rem 1rem rgba(0,0,0,0.15)',
				  borderRadius: '0.5rem',
				  border: '1px solid #dee2e6',
				  padding: '0.5rem 0',
				  marginTop: '0.5rem',
				  minWidth: '200px',
				  maxWidth: '90vw'
				}}

			  >
                  <ul className="nav flex-column">
                    <li className="nav-item">
                      <Link className="nav-link" to={withRandomParam("/home")} onClick={() => setMobileMenuOpen(false)}>Home</Link>
                    </li>
                    <li className="nav-item dropdown">
                      <a className="nav-link dropdown-toggle" href="#" id="alertDropdownMobile" data-bs-toggle="dropdown" aria-expanded="false">Alerts</a>
                      <ul className="dropdown-menu" aria-labelledby="alertDropdownMobile">
                        <li><Link className="dropdown-item" to={withRandomParam("/alerts/createalert")} onClick={() => setMobileMenuOpen(false)}>Create Alert</Link></li>
                        <li><Link className="dropdown-item" to={withRandomParam("/alerts/alertclient")} onClick={() => setMobileMenuOpen(false)}>Alert Client Association</Link></li>
                        <li><Link className="dropdown-item" to={withRandomParam("/alerts/repository")} onClick={() => setMobileMenuOpen(false)}>Alert Repository</Link></li>
                      </ul>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to={withRandomParam("/emails/displayEmailNotices")} onClick={() => setMobileMenuOpen(false)}>Mail Notice</Link>
                    </li>
					<Authorization allowed={['SUPER', 'ADMIN', 'ALL_PRIV']}>
					                  <li className="nav-item dropdown">
					                    <a className="nav-link dropdown-toggle" href="#" id="adminDropdownMobile" data-bs-toggle="dropdown" aria-expanded="false">Admin</a>
					                    <ul className="dropdown-menu" aria-labelledby="adminDropdownMobile">
					                      <li><Link className="dropdown-item" to={withRandomParam("/routing/displayRouting")} onClick={() => setMobileMenuOpen(false)}>Display Routings</Link></li>
					                      <li><Link className="dropdown-item" to={withRandomParam("/routing/resolveRouting")} onClick={() => setMobileMenuOpen(false)}>Resolve Routings</Link></li>
					                      <li><Link className="dropdown-item" to={withRandomParam("/datainfo/displayClientDataInfo")} onClick={() => setMobileMenuOpen(false)}>Client Data Upload Info</Link></li>
					                      <li><Link className="dropdown-item" to={withRandomParam("/datainfo/displayClientData")} onClick={() => setMobileMenuOpen(false)}>View Client Data</Link></li>
					                      <Authorization allowed={['ADMIN']}>
					                        <li><Link className="dropdown-item" to={withRandomParam("/trackutil")} onClick={() => setMobileMenuOpen(false)}>Tracking Utilities</Link></li>
					                      </Authorization>
					                    </ul>
					                  </li>
					                </Authorization>
                    <li className="nav-item">
                      <a className="nav-link" href={withRandomParam("/help")} target="_blank" rel="noopener noreferrer" onClick={() => setMobileMenuOpen(false)}>Help</a>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to={withRandomParam("/logout")} onClick={() => setMobileMenuOpen(false)}>Logout</Link>
                    </li>
                  </ul>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
